/* Veloria — fenêtre promo d'accueil + estimation des dates de livraison */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Dates de livraison estimées (jours ouvrés lun-ven) */
  const fmt = new Intl.DateTimeFormat("fr-FR", { weekday: "short", day: "numeric", month: "short" });
  function addBusinessDays(from, n) {
    const d = new Date(from);
    let left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      const wd = d.getDay();
      if (wd !== 0 && wd !== 6) left--;
    }
    return d;
  }
  function renderEstimates() {
    const today = new Date();
    $$("[data-ship-est]").forEach(box => {
      const [a, b] = (box.dataset.std || "3-5").split("-").map(Number);
      const el = $("[data-se-std]", box); if (!el) return;
      el.textContent = `entre le ${fmt.format(addBusinessDays(today, a))} et le ${fmt.format(addBusinessDays(today, b))}`;
    });
  }
  renderEstimates();

  /* ---------- Fenêtre promo */
  const promo = $("[data-promo]");
  if (!promo) return;
  const code = promo.dataset.code;
  const ends = promo.dataset.ends ? Date.parse(promo.dataset.ends) : NaN;
  const key = "v-promo-" + code;
  let seen = false;
  try { seen = !!sessionStorage.getItem(key); } catch (_) {}
  if ((!isNaN(ends) && Date.now() >= ends) || seen || /[?&]design_mode/.test(location.search)) return;

  const card = $(".promo-card", promo);
  let lastFocus = null, timer = null;

  function tick() {
    if (isNaN(ends)) return;
    const ms = ends - Date.now();
    if (ms <= 0) { close(); return; }
    const s = Math.floor(ms / 1000);
    const parts = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
    for (const k in parts) { const el = $(`[data-u="${k}"]`, promo); if (el) el.textContent = String(parts[k]).padStart(2, "0"); }
  }
  function open() {
    lastFocus = document.activeElement;
    promo.hidden = false;
    requestAnimationFrame(() => promo.classList.add("show"));
    document.body.classList.add("lock");
    tick(); timer = setInterval(tick, 1000);
    try { sessionStorage.setItem(key, "1"); } catch (_) {}
    setTimeout(() => $(".promo-cta", promo)?.focus({ preventScroll: true }), 400);
  }
  function close() {
    promo.classList.remove("show");
    clearInterval(timer);
    document.body.classList.remove("lock");
    setTimeout(() => { promo.hidden = true; }, 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  promo.addEventListener("click", e => { if (e.target.closest("[data-promo-close]")) close(); });
  document.addEventListener("keydown", e => {
    if (promo.hidden) return;
    if (e.key === "Escape") close();
    if (e.key === "Tab") {
      const f = $$("a,button", card).filter(x => !x.disabled);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  const copyBtn = $("[data-promo-copy]", promo);
  if (copyBtn) copyBtn.addEventListener("click", async () => {
    try { await navigator.clipboard.writeText(code); copyBtn.textContent = "Copié ✓"; }
    catch (_) { copyBtn.textContent = code; }
    setTimeout(() => (copyBtn.textContent = "Copier"), 2000);
  });

  /* Sur téléphone, la fenêtre attend que la visiteuse ait vu la page (6 s) */
  const mobile = matchMedia("(max-width: 760px)").matches;
  const delay = mobile ? 6000 : (document.documentElement.classList.contains("intro") ? 2600 : 1200);
  setTimeout(open, delay);
})();
